import axios from 'axios'
// import * as firebase from 'firebase/app'
// import 'firebase/auth'
import firebase from 'firebase'
import {getConfig} from '../config/config'
import OAlert from '../utils/OAlert/OAlert'
import i18n from '../assets/i18n/lang'

export const AuthService = {
    init: () => {
        return new Promise(
            function (resolve, reject) {
                const config = getConfig()
                axios.defaults.baseURL = config.networkingConfig.baseURL

                // add interceptor to get firebase id token. firebase automatically uses refresh token when id token is expired.
                axios.interceptors.request.use(
                    config => {
                        return firebase.auth().currentUser.getIdToken(true)
                            .then((idToken) => {
                                axios.defaults.headers.common['Authorization'] = idToken
                                config.headers.common['Authorization'] = idToken
                                return config
                            })
                            .catch((err) => {
                                console.log('couldnt get id token.' + err.message) // TODO: handle error -> commit error state
                            })
                    },
                    error => reject(error))

                // catch 401s
                axios.interceptors.response.use(
                    response => {
                        return response
                    },
                    error => {
                        OAlert.showFailure('', i18n.t('feedback.generalFail'))
                        return Promise.reject(error)
                    })
                resolve()
            })
    },
    logIn: (payload) => {
        return new Promise(
            function (resolve, reject) {
                firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
                    .then(() => { return firebase.auth().currentUser.getIdToken(true) })
                    .then((idToken) => { axios.defaults.headers.common['Authorization'] = idToken })
                    .then(() => resolve())
                    .catch((error) => reject(error))
            })
    },
    logInBackend: () => {
        return new Promise(
            function (resolve, reject) {
                axios.get('/login')
                    .then((response) => {
                        if (response.status === 200) {
                            resolve(response.data)
                        } else { reject(new Error('http status code other than 200: ' + response.status)) }
                    })
                    .catch((error) => reject(error))
            })
    },
    logOut: () => {
        return new Promise(
            function (resolve, reject) {
                firebase.auth().signOut()
                    .then(() => delete axios.defaults.headers.common['Authorization'])
                    .then(() => resolve())
                    .catch((error) => reject(error))
            })
    },
    recoverPassword: (payload) => {
        return new Promise(
            function (resolve, reject) {
                firebase.auth().sendPasswordResetEmail(payload.email)
                    .then(() => delete axios.defaults.headers.common['Authorization'])
                    .then(() => resolve())
                    .catch((error) => reject(error))
            })
    },
    getIdToken: (payload) => {
        return new Promise(
            function (resolve, reject) {
                return firebase.auth().currentUser.getIdToken(true)
                    .then((idToken) => resolve(idToken))
                    .catch((error) => reject(error))
            })
    },
    signUp: (payload) => {
        return new Promise(
            function (resolve, reject) {
                firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
                    .then(() => resolve())
                    .catch((error) => reject(error))
            })
    }
}



// WEBPACK FOOTER //
// ./src/services/auth-service.js